export default "__VITE_ASSET__613a2c50__"